module.exports = {"app.signInMessage":"TODO: sign in w/ {provider}.","app.authButtons":"Auth buttons","app.itemPager":"Item Pager"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en.json
// module id = 52
// module chunks = 0